<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qWdGZX/tc-custom/9780830864423.jpg?1696025613511" alt="This image is the cover for the book Prayer and Listening, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prayer and Listening, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Most Christians have experienced the "laundry list" phase of spiritual life, in which praying means giving God an agenda of needs to handle.</strong> But how do you move to having real conversation with God? How do you hear what God is saying back to you? How can you make your experience of God's presence part of everyday life?</p> <p>In this six-session LifeGuide® Bible Study, Jan Johnson covers the disciplines of prayer and of practicing God's presence. Going deeper in these areas will help you to draw closer to God in everything you do.</p> <p>For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan Johnson
      </h2>
      
      <p class="authorDescription body article"><p>Jan Johnson is the author of over twenty books and more than a thousand magazine articles and Bible studies. A speaker, teacher, and spiritual director, she writes primarily about spiritual formation, social justice, and living with purposeful intentionality. She holds a DMin in Ignatian spirituality and spiritual direction from the Graduate Theological Foundation and lives with her husband in Simi Valley, California. Her books include <em>Meeting God in Scripture</em>, <em>Abundant Simplicity</em>, <em>Hearing God Through the Year</em> (editor), <em>Enjoying the Presence of God</em>, and <em>Spiritual Disciplines Companion</em>. She is also the author of the LifeGuide Bible Studies title <em>Study and Meditation</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9f962a6